import { Link, Stack, Typography } from "@mui/material";
import React from "react";
import Title from "src/components/common/Title";
import { MarketTreeMapStyle } from "./MarketTreeMap.styles";

export const MarketsTreemapExplainer = () => {
  // ------------------Constants---------------------------

  const title = {
    partA: "Token",
    partB: "Map",
  };
  const supportArticle = "https://support.calebandbrown.com/en/articles/6575765-market-sectors";
  const explainerDesc = `Deep dive into the market using our Token Map, sort by volume, market cap and filter the timeframe. Learn more about this feature and how to navigate it `;
  // ------------------Style Sheet---------------------------
  const classes = MarketTreeMapStyle();

  return (
    <>
      <Stack spacing={1} direction="row">
        <Title title={title} />
      </Stack>
      <Typography id="treeMapExplainer" className={classes.subTitle}>
        {explainerDesc}
        <Link rel="noreferrer" target="_blank" href={supportArticle}>
          here.
        </Link>
      </Typography>
    </>
  );
};
